import {LogoBrand} from './LogoBrand.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

const LION_PATH = 'M22 78c-2-10 3-18 10-22-4-6-3-14 2-18 1 4 4 6 7 6-2-5 0-11 5-13-1 4 1 7 4 8 3-6 10-9 16-7-4 2-6 5-6 9 5-1 10 2 12 7-4-1-8 0-10 3 6 2 10 8 9 15-3-4-7-6-11-6 3 5 3 12-1 16-1-4-4-7-8-8 1 6-2 12-7 14 0-3-1-5-3-7-3 5-9 8-15 6 3-1 5-3 6-6-6 1-12-2-15-8 3 2 6 2 9 1-4-3-6-8-6-13z';

function Face() {
    return (
        <>
            <div className="absolute inset-0 bg-[linear-gradient(160deg,#FF7A1A_0%,#FF6200_46%,#F25A00_100%)]" />
            <svg aria-hidden className="absolute bottom-[6%] right-[5%] w-[34%] opacity-[0.14]" viewBox="0 0 100 100">
                <path fill="#7A2C00" d={LION_PATH} />
            </svg>
        </>
    );
}

export const ingSkin: BankCardSkin = {
    Face,
    Brand: LogoBrand,
    chipTone: ChipTone.Gold,
    hasMastercard: true,
    surfaceTone: 'dark',
    contentColor: '#FFFFFF',
    labelColor: 'rgba(255, 255, 255, 0.85)',
    contactlessColor: '#FFF2E6',
    mastercardWordColor: '#2B1500',
};
